<div class="table-row" [class.selected-row]="isChecked" [attr.data-test]="'table-row-' + index">
  <div class="actions-cell" (click)="onCheck(user)" *ngIf="canRemoveUser">
    <input
      type="checkbox"
      class="checkbox-input"
      [attr.data-test]="'checkbox-' + index"
      [ngModel]="isChecked"
    />
  </div>
  <div class="user-first-name">
    <div class="sm-flex sm-flex-row sm-items-center sm-space-x-2">
      <cc-user-avatar [user]="user"></cc-user-avatar>
      <span class="text-truncate" [innerHTML]="user?.firstName | textEmphasis: searchTerm:'bold'"></span>
    </div>
  </div>
  <div class="user-last-name">
    <span class="text-truncate" [innerHTML]="user?.lastName | textEmphasis: searchTerm:'bold'"></span>
  </div>
  <div class="user-email">
    <span
      class="text-truncate"
      [title]="user?.email"
      [innerHTML]="user?.email | textEmphasis: searchTerm:'bold'"
    ></span>
  </div>
  <div class="permission-toggle sm-pr-2" *ngIf="showPermissionToggle">
    <cc-user-permission-toggle
      [user]="user"
      [permissionOptions]="permissionOptions"
      [canUpdateUserPermission]="canUpdateUserPermission"
      (onUpdatePermission)="onUpdatePermission.emit()"
    ></cc-user-permission-toggle>
  </div>
</div>
